import { Reeller } from "reeller";
import { ScrollerPlugin } from "reeller";
import { gsap } from "gsap";

Reeller.registerGSAP(gsap);
Reeller.use(ScrollerPlugin);

export default function initGsapMarquee() {
    const marquees = document.querySelectorAll(".marquee");
    if (!marquees) return;

    marquees.forEach((el) => {
        const reeller = new Reeller({
            container: el,
            wrapper: ".marquee__track",
            itemSelector: ".marquee__item",
            speed: el.dataset.marqueeSpeed || 10,
            autoStop: !("marqueePersistent" in el.dataset),
            plugins: {
                scroller: {
                    reversed: "marqueeReversed" in el.dataset,
                },
            },
        });

        reeller.resume();
    });
}
